/* eslint-disable max-len */
import styled from 'styled-components'
import tokens from '../tokens'
import serviceProductConstant from '../../constants/service-product'

const { fonts, colors } = tokens
const {
  serviceProductType: { HC }
} = serviceProductConstant

export const Style = styled.div`
  .container-service-product {
    margin-bottom: 50px;
  }
  .slider-advantage-dot {
    display: flex;
    margin: 0 auto;
    padding: 0;
    justify-content: center;
    &-number {
      border: 1px solid #fff;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: ${props => props.dotBackground || 'rgba(0,0,0,0.1)'};
      color: ${props => props.dotColor || '#fff'};
      &:hover {
        background: #fff;
        color: #ffb66e;
      }
    }
    .slick-active {
      > div {
        color: ${props => props.dotColorActive || 'rgba(0,0,0,0.1)'};
        background: ${props => props.dotBackgroundActive || '#fff'};
      }
    }
  }
  .content-service-product {
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-left: -20px;
    margin-right: -20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 70px;
    padding-bottom: 60px;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
  .title-service-content {
    font-family: ${fonts.fontFamilyBasic};
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: 0.31px;
    display: ${props => props.display || 'unset'};
    color: ${props => (props.content === HC ? colors['ui-white'] : '#333333')};
    text-align: ${props => props.align || 'unset'};
  }
  .subtitle-service-content {
    margin-top: 14px;
    font-family: ${fonts.fontFamilyBasic};
    font-size: 14px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: 0.31px;
    display: ${props => props.display || 'unset'};
    color: ${props => (props.content === HC ? colors['ui-white'] : '#333333')};
    text-align: ${props => props.align || 'unset'};
  }
  .container-product {
    margin-top: 70px;
    display: grid;
    grid-template-columns: auto auto auto auto;
    justify-content: center;
    gap: 20px;
    width: 100%;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .content-product {
    padding: 20px;
    border-radius: 14px;
    background: ${colors['ui-white']};
    text-align: center;
    margin-top: 36px;
    margin-bottom: 36px;
  }
  .image-product {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .title-product {
    margin-top: 10px;
    font-family: ${fonts.fontFamilyBasic};
    line-height: 24px;
    font-size: 14px;
    font-weight: bold;
    font-weight: ${props => props['fontWeight'] || 'regular'};
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.18px;
    color: #333333;
    text-align: ${props => props.align || 'unset'};
  }
  .subtitle-product {
    margin-top: 10px;
    margin-bottom: 10px;
    font-family: ${fonts.fontFamilyBasic};
    line-height: 24px;
    font-size: 13px;
    font-weight: ${props => props['fontWeight'] || 'regular'};
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.18px;
    color: #333333;
    text-align: ${props => props.align || 'unset'};
  }
  .button-detail {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .text-button {
    margin-right: 10px;
    font-family: ${fonts.fontFamilyBasic};
    line-height: 24px;
    font-size: 14px;
    font-weight: bold;
    font-weight: ${props => props['fontWeight'] || 'regular'};
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.18px;
    color: #498fdf;
    text-align: ${props => props.align || 'unset'};
  }
`
